var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgUserIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.33343 5.33333C6.33343 4.41286 7.07962 3.66667 8.0001 3.66667C8.92057 3.66667 9.66677 4.41286 9.66677 5.33333C9.66677 6.25381 8.92057 7 8.0001 7C7.07962 7 6.33343 6.25381 6.33343 5.33333ZM8.0001 2.66667C6.52734 2.66667 5.33343 3.86057 5.33343 5.33333C5.33343 6.80609 6.52734 8 8.0001 8C9.47286 8 10.6668 6.80609 10.6668 5.33333C10.6668 3.86057 9.47286 2.66667 8.0001 2.66667ZM4.01504 11.7391C4.24062 11.3119 4.61003 10.8427 5.22187 10.4775C5.83412 10.112 6.71828 9.83333 8.00008 9.83333C9.28188 9.83333 10.166 10.112 10.7783 10.4775C11.3901 10.8427 11.7595 11.3119 11.9851 11.7391C12.0648 11.89 12.0396 12.0089 11.9588 12.1104C11.8647 12.2286 11.6774 12.3333 11.4351 12.3333H4.56508C4.32277 12.3333 4.13542 12.2286 4.04133 12.1104C3.96051 12.0089 3.93536 11.89 4.01504 11.7391ZM8.00008 8.83333C6.56989 8.83333 5.50194 9.14568 4.70933 9.6188C3.91633 10.0922 3.42814 10.709 3.13078 11.2721C2.85494 11.7944 2.94524 12.3393 3.25906 12.7334C3.55962 13.1108 4.04612 13.3333 4.56508 13.3333H11.4351C11.954 13.3333 12.4405 13.1108 12.7411 12.7334C13.0549 12.3393 13.1452 11.7944 12.8694 11.2721C12.572 10.709 12.0838 10.0922 11.2908 9.6188C10.4982 9.14568 9.43027 8.83333 8.00008 8.83333Z",
    fill: "#576270"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUserIcon);
export default __webpack_public_path__ + "static/media/user_icon.1dbf01fff70cf110f914f4ad2b0f02bc.svg";
export { ForwardRef as ReactComponent };